var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable } from "mobx";
/**
* QALineInfo defines event for racing braches.
*
* @typedef QALineInfo
* @type {Object}
* @property {id} Unique identifier
* @property {odds} current line odds
* @property {lineName} Name of the Line
* @property {fractOddsDividend} Dividend for fractional odds
* @property {fractOddsDivisor} Divisor for fractional odds
* @property {lineStateId} Determines if the line is withdrawns
* @property {forecastEnabled} Determines if forecast is enabled for event
* @property {tricastEnabled}  Determines if tricast is enabled for event
* @property {feedSelectionId} SelectionId provided by the feed
* @property {lineTypeId} Type of the line
*/
var QALineInfo = /** @class */ (function () {
    function QALineInfo(source) {
        this.id = source.id;
        this.odds = source.odds;
        this.lineName = source.lineName;
        this.fractOddsDividend = source.fractOddsDividend;
        this.fractOddsDivisor = source.fractOddsDivisor;
        this.lineTypeName = source.lineTypeName;
        this.feedSelectionId = source.feedSelectionId;
        this.lineStateId = source.lineStateId;
        this.qaParameter1 = source.qaParameter1;
        this.qaParameter2 = source.qaParameter2;
        this.lineTypeId = source.lineTypeId;
    }
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], QALineInfo.prototype, "odds", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], QALineInfo.prototype, "fractOddsDividend", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], QALineInfo.prototype, "fractOddsDivisor", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], QALineInfo.prototype, "lineStateId", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], QALineInfo.prototype, "qaParameter1", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], QALineInfo.prototype, "qaParameter2", void 0);
    return QALineInfo;
}());
export { QALineInfo };
//# sourceMappingURL=QALineInfo.js.map